module.exports = __webpack_public_path__ + "img/companion_3.e9c80b00.svg";